export default __webpack_public_path__ + "static/media/ff3.fe59ec32.jpg";